<template>
  <div class="A1">
    <!-- 头部 -->
    <Header></Header>
    <!-- 内页大图 -->
    <Banner></Banner>
    <!-- 面包屑 -->
    <Breadcrumb></Breadcrumb>
    <!-- 内容 -->
    <div class="container">
      <div class="wrap">
        <div class="list">
          <router-link :to="{path:'/ActivityA1Detail/'+item.id}" tag="div" class="item" :key="index" v-for="(item,index) in dataList">
           <img class="item-l" :src="item.picUrl" alt="">
           <div class="item-r">
             <div class="title text-hide">{{item.title}}</div>
             <div class="info">
               <p>活动时间：{{item.date}}</p>
               <p>活动地点：{{item.address}}</p>
               <p>活动类型：{{item.age}}</p>
               <p>活动费用：{{item.money}}</p>
             </div>
             <button class="btn over">{{item.isOver}}</button>
           </div>
          </router-link>
          <div style="clear: both"></div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[5, 10, 15, 20, 25]"
            :page-size="5"
            layout="total, sizes, prev, pager, next, jumper"
            :total="config.total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import {listShowHd} from "@/api"
  // import {getActivityA1} from "@/api"
  import Header from "@/common/Header";
  import Footer from "@/common/Footer";
  import Banner from "@/common/Banner";
  import Breadcrumb from "@/common/Breadcrumb";
  import {mixin} from '@/mixin/index'

  export default {
    name: "List",
    mixins:[mixin],
    components: {
      Header,
      Footer,
      Banner,
      Breadcrumb
    },
    data(){
      return{
        config: {
          classify: '',
          total: 0,
          page: 1,
          limit: 5
        },
        dataList:[]
      }
    },
    watch:{
      '$store.getters.lang' : function(val) {
        this.toGetData()
      }
    },
    created(){
      // 设置背景颜色
      document.body.style.backgroundColor = "#f6f8fa"
      // 获取数据
      this.toGetData()
    },
    methods:{
      // 获取数据
      async toGetData() {
        this.dataList = []
        let params = {
          pageNum: this.config.page,
          pageSize: this.config.limit,
          orderByColumn: "create_time",
          articleClass: this.$store.getters.lang,
        }
        let {data:{rows,total}} = await listShowHd(params)

        rows.forEach( val => {
          let _bEffect = "";
          let _freeC = "";
          // if(this.$store.getters.lang=='en'){
          //   _bEffect = val.bEffect=="0" ? "Finished" : val.bEffect=="1"?"Reservation" :''
          //   _freeC = val.bFree=="0" ? "Not Free" : val.bFree=="1"?"Free" :''
          // }else{
            _bEffect = val.bEffect=="0" ? "已结束" : val.bEffect=="1"?"可预约 " :''
            _freeC = val.bFree=="0" ? "收费" : val.bFree=="1"?"免费" :''
          // }

          this.dataList.push({
            id : val.id,
            // title : this.$store.getters.lang == 'en' ?val.showhdTitleEn:val.showhdTitle,
            title : val.showhdTitle,
            date : val.beginDay + ' '+ val.beginTime + '——'　+ val.endDay + ' '+ val.endTime,
            // address : this.$store.getters.lang == 'en' ?val.showhdAddressEn:val.showhdAddress,
            // age : this.$store.getters.lang == 'en' ?val.showhdTypeEn:val.showhdType,
            address : val.showhdAddress,
            age : val.showhdType,
            money : _freeC, // 是否收费
            isOver : _bEffect,  // 是否结束
            picUrl : this.$store.getters.urlApi + val.showhdFace,
          })
        })
        this.config.total = total
      },
      // toGetData() {
      //   getActivityA1(this.config).then((res) => {
      //     this.dataList = res.data.data.list
      //     this.config.total = res.data.data.count
      //   })
      // },
      // 分页事件
      handleSizeChange(val) {
        this.config.limit = val
        this.toGetData()
      },
      handleCurrentChange(val) {
        this.config.page = val
        this.toGetData()
      }
    }
  }
</script>

<style scoped lang="less">
  body {
    background: #f6f6f6;
  }
  .el-pagination {
    text-align: center;
    padding-top: 50px;
  }
  .container{
    .wrap{
      width: 1380px;
      background: #FFFFFF;
      padding: 60px;
      margin: 0 auto 80px;
      .list{
        .item {
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          padding-top: 50px;
          padding-bottom: 50px;
          border-bottom: 1px solid #e3e3e3;
          .item-l{
            width: 380px;
            height: 242px;
          }
          .item-r{
            width: 820px;
            .title{
              font-family: PingFangSC;
              font-weight: 600;
              font-size: 28px;
              color: #333333;
            }
            .info{
              font-family: Source Han Sans CN;
              font-size: 20px;
              color: #666666;
              line-height: 32px;
              margin-top: 10px;
            }
            .btn{
              cursor: pointer;
              width: 130px;
              height: 46px;
              background: #C71010;
              border-radius: 10px;
              font-family: PingFangSC;
              font-size: 20px;
              color: #FFFFFF;
              line-height: 46px;
              margin-top: 30px;
            }
            .btn.over{
              background: #999999;
            }
          }
        }
        .item:nth-child(1){
          padding-top: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Activity/A1/List.vue